import { motion } from "framer-motion";

const STEPS = [
  { code: "01", title: "THE STREETS", text: "Gang involvement, addiction, and survival mode — the symptoms everyone sees." },
  { code: "02", title: "INCARCERATION", text: "Time inside forced the question nobody had asked: what is underneath all of this?" },
  { code: "03", title: "THE ROOT", text: "The answer was trauma — never dealt with, never named, driving every decision." },
  { code: "04", title: "THE BOOK", text: "The Hood's Curriculum: Turning Lived Experience into Political Power turned that reckoning into a framework others can follow." },
  { code: "05", title: "THE STRATEGIST", text: "Today Angel Garcia brings that framework back inside — as leadership training for the people still there." },
];

const renderManifesto = (text) => {
  const parts = (text || "").split(/(TRAUMA\.|Success is a mindset, but so is recidivism\.)/g);
  return parts.map((p, i) => {
    if (p === "TRAUMA.") return <span key={i} className="text-red-500 font-bold">{p}</span>;
    if (p === "Success is a mindset, but so is recidivism.") return <span key={i} className="text-amber-500 font-semibold">{p}</span>;
    return <span key={i}>{p}</span>;
  });
};

export default function ManifestoSection({ content }) {
  return (
    <section id="manifesto" className="relative py-28 lg:py-36 grain" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <div className="lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
              className="font-mono-tactical text-xs uppercase tracking-[0.25em] text-amber-500"
            >
              The Founder's Truth
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-5 font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#F3F4F6]"
              data-testid="manifesto-heading"
            >
              I didn't read about this life in a textbook.
            </motion.h2>
            <motion.blockquote
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-7 border-l-2 border-amber-500 pl-6 text-base sm:text-lg text-[#9CA3AF] leading-relaxed"
              data-testid="manifesto-quote"
            >
              {renderManifesto(content.manifesto)}
            </motion.blockquote>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.35 }}
              className="mt-6 font-mono-tactical text-[11px] tracking-[0.2em] text-[#6B7280]"
            >
              — ANGEL GARCIA, AUTHOR & FOUNDER
            </motion.p>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative pl-8 border-l border-white/10">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.code}
                initial={{ opacity: 0, x: 32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="relative pb-12 last:pb-0 group"
                data-testid={`timeline-step-${s.code}`}
              >
                <span className="absolute -left-[41px] top-0 w-5 h-5 rounded-full border-2 border-amber-500 bg-[#0D0E11] group-hover:bg-amber-500 transition-colors" />
                <div className="font-mono-tactical text-xs text-amber-500 tracking-[0.2em]">{s.code}</div>
                <h3 className="mt-1 font-display font-bold text-xl sm:text-2xl text-[#F3F4F6] tracking-tight">{s.title}</h3>
                <p className="mt-2 text-[#9CA3AF] text-sm sm:text-base leading-relaxed max-w-md">{s.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
